module.exports = __webpack_public_path__ + "img/314.0a8eac9f.png";